module.exports = __webpack_public_path__ + "img/pen-tool-purple.27c18449.svg";